import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import { ReportViewerType } from "../../../components/ReportViewer/ReportViewer.types";
import { InspectionStandardDTO } from "../../../common/types/common.dto.types";

const client = new ApiClient();

export const getInspectionStandardQuestionnaireReport = async (
  params: InspectionStandardDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `InspectionQuestion/GetInspectionStandardQuestionExcelData`;

    let reportData = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, params)
      .then((response: ActionResponseType) => {
        reportData = response;
      })
      .catch((error) => {
        // console.log(error);
        reportData = {} as ActionResponseType;
        throw error;
      });
    return reportData;
  } catch (error) {
    throw error;
  }
};

const getInspectionStandardQuestionnaireReportApi = {
  getInspectionStandardQuestionnaireReport,
};

export default getInspectionStandardQuestionnaireReportApi;
